
// import { UserApi } from '@/api';
import { pageRoutes } from '@/components/routes';
import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';

interface IUser {
    user: IUserContext | null;
    setUser: (user: IUserContext | null) => void;
}
// Create a context
const UserContext = createContext<IUser | null>(null);

// Create a provider component
export const UserProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [user,setUser] = useState<IUserContext | null>( window.user); // Initialize user state

    // const publicRoutes = [
    //     ``,
    //     `/`,
    //     `/${process.env.PREFIX_EDUCATOR_REGISTER}`,
    //     `/${process.env.PREFIX_EDUCATOR_REGISTER}/`,
    //     `/${process.env.PREFIX_SUMMIT_FINALIST}`,
    //     `/${process.env.PREFIX_SUMMIT_FINALIST}/`,
    //     `/${process.env.PREFIX_TCC_SUMMIT_PAGE}`,
    //     `/${process.env.PREFIX_TCC_SUMMIT_PAGE}/`,
    //     `/${process.env.PREFIX_EDUCATALYST}`,
    //     `/${process.env.PREFIX_EDUCATALYST}/`,
    //     `/${process.env.PREFIX_THOUGHTCOCREATE}`,
    //     `/${process.env.PREFIX_THOUGHTCOCREATE}/`,
    //     `/${process.env.PREFIX_THOUGHTCOCREATE}/rules-and-guidelines`,
    //     `/${process.env.PREFIX_THOUGHTCOCREATE}/rules-and-guidelines/`,
    //     `/rules-and-guidelines`,
    //     `/rules-and-guidelines/`];

    const publicRoutePrefixes = [
        "", // Dành cho root path "/"
        "/", // Cũng dành cho root path "/"
        `/${process.env.PREFIX_EDUCATOR_REGISTER}`,
        `/${process.env.PREFIX_SUMMIT_FINALIST}`,
        `/${process.env.PREFIX_TCC_SUMMIT_PAGE}`,
        `/${process.env.PREFIX_EDUCATALYST}`, // Thêm toàn bộ tiền tố educatalyst
        `/${process.env.PREFIX_THOUGHTCOCREATE}`,
        `/${process.env.PREFIX_THOUGHTCOCREATE}/rules-and-guidelines`,
        `/rules-and-guidelines`, // Đề phòng trường hợp đường dẫn không có prefix "wordpress/"
    ];

    useEffect(() => {
        const currentPath = window.location.pathname;

        const isPublicRoute = publicRoutePrefixes.some(prefix => 
            currentPath === prefix || 
            currentPath.startsWith(`${prefix}/`) ||
            (prefix === "" && currentPath === "/wordpress/") // Xử lý trường hợp root của wordpress
        );
        if (
            (user?.user_login == null || typeof user?.user_login === "undefined") &&
            !isPublicRoute
        ) {
            window.location.href = user?.login_url || "/";
        }
        // if(user?.role != process.env.ACCESS_ROLE){
        //     window.location.href = user?.home_url || "/";
        // }
        // else {
        //     UserApi.getUserWorkspaces().then((res) => {
        //         var newUser = {...user,...res};
        //         // console.log(newUser);
        //         setUser(newUser);
        //     }).catch((err) => {
        //         console.error("Error in get user workspaces:", err);
        //     });
        // }
    }, []);

    return (
        <UserContext.Provider value={{ user, setUser }}>
            {children}
        </UserContext.Provider>
    );
};

// Custom hook to use the UserContext
export const useUser = () => {
    const context = useContext(UserContext);
    if (!context) {
        throw new Error('useUser must be used within a UserProvider');
    }
    return context;
};